export const MODIFY_TITLE_FONT_SKU = [
  'SST22066CP',
  'XKM23081CP',
  'AWHG210U26CP',
  'AWEH220U33CP',
  'AWHG210U21CP',
  'AWSSH200U2CP1010',
  'AWSST220U11CP',
  'AWSST220U09CP',
  'ZH23069CP',
  'AWHG213U66CP',
  'LDJ25002CP',
  'SBM23084CP',
  'AWLFAW196U1CP',
  'LF24245CP',
  'WD110009',
  'FST24085CP',
  'MZTZ25005CP',
  'LPB23155CP',
  'AWYD130U026CP',
  'JJF2202WCP',
  'AWJJFAW210U5WCP',
  'AWPJ190U1CP',
  'HX2302CP',
  'PJ23282CP',
  'TS21009CP',
  'AWHSAW210U17CP',
  'SL21007CP',
  'XKM23080CP',
  'AWHG212U22CP',
  'AWEH220U30CP',
  'AWHG213U17CP',
  'AWEH220U34CP',
  'AWEH220U41CP',
  'AWSST220U12CP',
  'ZH1801W2CP',
  'AWHG213U18CP',
  'LDJ25003CP',
  'SBM23085CP',
  'SSH2002CP',
  'XL23067CP',
];
